export default __webpack_public_path__ + "static/media/iphone.0c24c5ba.png";